module.exports = __webpack_public_path__ + "static/img/list-bg-3.231167e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/list-bg-3.png
// module id = FRWy
// module chunks = 1